const Reporting = () => (
  <h2>Reporting</h2>
);

export default Reporting;
